import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "./pages/Login"
import ChangePasswordPage from "./pages/ChangePassword"
import NotFoundPage from './pages/NotFound';
import { UserContext } from './context/UserContext';
import { useContext } from 'react';
import StoreDeploymentPage from './pages/StoreDeployment';
import CamerasReviewPage from './pages/CamerasReview';

export default function App() {
  const { token, username } = useContext(UserContext)

  return (
    <div className="App">
      {token ?
        <Routes>
          <Route path="/" element={<Navigate replace to={'/0'} />} />
          <Route path="/change-password" element={<ChangePasswordPage username={username} />} />
          <Route path="/not-found" element={<NotFoundPage />} />
          <Route path="/:deploymentId" element={<StoreDeploymentPage />} />
          <Route path="/:deploymentId/cameras-review" element={<CamerasReviewPage />} />
          <Route path="*" element={<Navigate to="/not-found" />} />
        </Routes>
        :
        <Login />
      }
    </div>
  );
}
